module.exports = __webpack_public_path__ + "static/img/zibo1.05a82b48.jpg";